export default __webpack_public_path__ + "static/media/february.824960ed.jpg";